<!-- <div class="back-container">
   <div class="back" routerLink="/login">
        <frg-inline-svg stroke="var(--primary)" class="back-icon" src="assets/icons/chevron-left.svg"></frg-inline-svg>
        <div class="back-text">Connexion</div>
    </div>
</div> -->
<form [formGroup]="passwordForm" class="login-card-content" (ngSubmit)="onSubmit()">
    <div class="inputs-container">
        <frg-form-input placeholder="Adresse email" label="Adresse email"  id="email"
            errorMessage="Veuillez entrer une adresse email valide" type="text" [formGroup]="passwordForm"
            [control]="passwordForm.get('email')" required="true"></frg-form-input>
        <frg-form-input placeholder="Ancien mot de passe" label="Ancien mot de passe" id="oldPassword"
            errorMessage="Veuillez entrer votre ancien mot de passe" type="password" [formGroup]="passwordForm"
            [control]="passwordForm.get('oldPassword')" required="true"></frg-form-input>
        <frg-form-input placeholder="Nouveau mot de passe" label="Nouveau mot de passe" id="newPassword"
            errorMessage="Le mot de passe ne respecte pas les règles requises" type="password" [formGroup]="passwordForm"
            [control]="passwordForm.get('newPassword')" required="true"></frg-form-input>
        <div class="password-rules">
            <div *ngFor="let rule of passwordRules" class="rule"
                [ngClass]="{ 'valid': rule.valid, 'invalid': newPasswordControl.touched && !rule.valid }">
                ● {{ rule.label }}
            </div>
        </div>
        <frg-form-input placeholder="Confirmation mot de passe" label="Confirmation mot de passe" id="confirmPassword"
            errorMessage="Les mots de passe doivent être identiques" type="password" [formGroup]="passwordForm"
            [control]="passwordForm.get('confirmPassword')" required="true"></frg-form-input>
    </div>
    <div class="buttons-container">
        <div class="connect-button-container">
            <button type="submit" class="button">
                Valider le nouveau mot de passe
                <div class="icon-container">
                    <div class="icon">
                    </div>
                </div>
            </button>
        </div>
    </div>
    <div class="error-container login-error" [ngClass]="{'no-height': !errorLogin}">
        Identifiants incorrects
    </div>
</form>
